import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { ForgotPassword } from './model';

import { ActionLoadingIndicator } from 'core/actionloadingindicator/view';
import { ValidationErrorView } from 'core/validationerror/view';

export const ForgotPasswordView = SuperCritical(({ model: m } : { model : ForgotPassword }) =>
    <div className="forgotpassword pc-page-fixedwidth">
        <div className="forgotpassword-container pc-card">
            <h2 className="pc-card-header pc-card-title">Forgot password</h2>
            {m.ForgotPasswordRequest()
                && m.ForgotPasswordRequest()!.Response()
                && m.ForgotPasswordRequest()!.Response()!.Success ?
                    <ForgotPasswordSuccess model={m} /> :
                    <ForgotPasswordForm model={m} />
            }
        </div>
    </div>
);

let ForgotPasswordForm = SuperCritical(({ model: m } : { model : ForgotPassword }) =>
    <form>
        <ActionLoadingIndicator loading={() => !!m.ForgotPasswordRequest() && !m.ForgotPasswordRequest()!.Response()} />
        <div>
            Please enter your email. A password reset link will be
            emailed to you.
        </div>
        <div className="email form-group">
            <input className="form-control pc-input-box"
                placeholder="Email" autoFocus
                value={m.ForgotPassword.Email()}
                onChange={e => m.ForgotPassword.Email(e.currentTarget.value)} />
            <ValidationErrorView error={() => m.Validation()['Email']} />
        </div>
        <div className="control-btns form-group">
            <a href="#" className="pc-cancel-link">Cancel</a>
            <button className="pc-button" onClick={noDefault(m.Submit)}>Request Reset</button>
        </div>
    </form>
);

let ForgotPasswordSuccess = SuperCritical(({ model: m } : { model : ForgotPassword }) =>
    <div>
        <div>
            A password reset link has been sent to
            {' '}
            {m.ForgotPassword.Email()}.
            {' '}
            Check your email and follow the instructions there.
        </div>
        <div className="homepage-link">
            <a href="#">Back to homepage</a>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/forgotpassword/view.tsx